import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const outcomeOfConsultationForm: Form<Client> = {
  key: 'outcomeOfConsultation',
  title: 'Ergebnis der Beratung',
  fields: [
    {
      key: 'appointmentForCounselling',
      label: 'Vereinbarter Beratungstermin',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'appointmentDate',
      label: 'Datum des Beratungstermins',
      fieldTypes: 'date',
      isVisible: (client) => client.appointmentForCounselling === true,
    },
    {
      key: 'appointmentTime',
      label: 'Uhrzeit des Beratungstermins',
      fieldTypes: 'text',
      isVisible: (client) => client.appointmentForCounselling === true,
    },
    {
      key: 'appointmentAdvisor',
      label: 'Beratungstermin bei',
      fieldTypes: 'text',
      isVisible: (client) => client.appointmentForCounselling === true,
    },
    {
      key: 'appointmentTookPlace',
      label: 'Beratungstermin hat',
      fieldTypes: 'select',
      isVisible: (client) => client.appointmentForCounselling === true,
      options: [
        {
          value: 'tookPlace',
          label: 'war da',
        },
        {
          value: 'cancelled',
          label: 'abgesagt',
        },
        {
          value: 'truant',
          label: 'unentschuldigt nicht erschienen',
        },
      ],
    },
    {
      key: 'appointmentTopic',
      label: 'Beratung über Umgangs- und Verhaltensmöglichkeiten',
      fieldTypes: 'text',
      xsWidth: 12,
      isVisible: (client) => client.appointmentForCounselling === true,
    },
    {
      key: 'appointmentTreatmentOptions',
      label: 'Empfehlung von Behandlungsmöglichkeiten',
      fieldTypes: 'select',
      isVisible: (client) => client.appointmentForCounselling === true,
      options: [
        {
          value: 'ambulant',
          label: 'ambulant',
        },
        {
          value: 'stationary',
          label: 'stationär',
        },
        {
          value: 'otherInstitution',
          label: 'andere Instituation',
        },
        {
          value: 'medical',
          label: 'ärztlich',
        },
        {
          value: 'group',
          label: 'Gruppe',
        },
      ],
    },
    {
      key: 'appointmentTreatmentInstitution',
      label: 'Andere Institution',
      fieldTypes: 'text',
      isVisible: (client) =>
        client.appointmentForCounselling === true && client.appointmentTreatmentOptions === 'otherInstitution',
    },
    {
      key: 'appointmentTreatmentGroup',
      label: 'Gruppe',
      fieldTypes: 'text',
      isVisible: (client) =>
        client.appointmentForCounselling === true && client.appointmentTreatmentOptions === 'group',
    },

    {
      key: 'psychosocialCounselling',
      label: 'Psychosoziale Beratung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'crisisintervention',
      label: 'Krisenintervention',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'information',
      label: 'Information',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'informationTopic',
      label: 'Information zu',
      fieldTypes: 'text',
      xsWidth: 8,
      isVisible: (client) => client.information === true,
    },
    {
      key: 'nutritionCounselling',
      label: 'Ernährungsberatung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'other',
      label: 'Sonstiges',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'otherTopic',
      label: 'Sonstiges',
      fieldTypes: 'text',
      xsWidth: 8,
      isVisible: (client) => client.other === true,
    },
  ],
};

export default outcomeOfConsultationForm;
